'use strict';

var memo = require('../../../../../motion-utils/dist/es/memo.cjs');

const supportsScrollTimeline = /* @__PURE__ */ memo.memo(() => window.ScrollTimeline !== undefined);

exports.supportsScrollTimeline = supportsScrollTimeline;
//# sourceMappingURL=scroll-timeline.cjs.map
